/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import { enableInitializing } from 'initializable-reducer';
import _ from 'lodash';

const initialState = {};

function schoolGeneralIntelligenceHistory(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_SCHOOL_GENERAL_INTELLIGENCE_HISTORY':
      if (responseHasError(payload)) {
        return state;
      }

      const { intelligence_id, group_by } = payload._meta.payload.request;

      const newHistory = {
        [intelligence_id]: {
          [group_by]: payload.body
        }
      };

      return _.assign({}, state, newHistory);
    default:
      return state;
  }
}

export {
  schoolGeneralIntelligenceHistory,
  initialState
};

export default enableInitializing(schoolGeneralIntelligenceHistory);
